(function () {
  function init(container) {
    if (!container) return;
    if (container.dataset.blogsPaginationInitialized === "1") return;
    const list = container.querySelector(".blogs-list__articles");
    const items = list
      ? Array.from(list.querySelectorAll(".blogs-list__article-item"))
      : [];
    if (items.length === 0) {
      if (!list) return;
      const observer = new MutationObserver(function () {
        if (container.dataset.blogsItemsReady !== "1") return;
        const nextItems = Array.from(
          list.querySelectorAll(".blogs-list__article-item"),
        );
        if (nextItems.length === 0) return;
        observer.disconnect();
        init(container);
      });
      observer.observe(list, { childList: true, subtree: false });
      return;
    }

    container.dataset.blogsPaginationInitialized = "1";

    const perPage = parseInt(container.dataset.postsPerPage, 10) || 12;
    const paginationType = (
      container.dataset.paginationType || "pagination"
    ).toLowerCase();
    const isLoadMore = paginationType === "load_more";
    const sortBy = (container.dataset.sort || "title_asc").toLowerCase();

    function sortKeyPublished(el) {
      return parseInt(el.dataset.published || "0", 10);
    }

    function sortKeyUpdated(el) {
      const u = parseInt(el.dataset.updated || "0", 10);
      if (u > 0) return u;
      return sortKeyPublished(el);
    }

    function scrollBlogsListToTop() {
      const section = container.closest(".blogs-list-template");
      const target = section || container;
      try {
        const y = target.getBoundingClientRect().top + window.scrollY - 16;
        window.scrollTo({ top: Math.max(0, y), behavior: "smooth" });
      } catch (_) {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }

    items.sort(function (a, b) {
      if (sortBy === "title_desc" || sortBy === "title_asc") {
        const titleA = (a.dataset.title || "").toLowerCase();
        const titleB = (b.dataset.title || "").toLowerCase();
        const cmp = titleA.localeCompare(titleB, undefined, {
          sensitivity: "base",
        });
        return sortBy === "title_desc" ? -cmp : cmp;
      }
      if (sortBy === "updated_desc" || sortBy === "updated_asc") {
        const ua = sortKeyUpdated(a);
        const ub = sortKeyUpdated(b);
        if (sortBy === "updated_desc") return ub - ua;
        return ua - ub;
      }
      const dateA = sortKeyPublished(a);
      const dateB = sortKeyPublished(b);
      if (sortBy === "date_desc") return dateB - dateA;
      return dateA - dateB;
    });

    items.forEach(function (item) {
      list.appendChild(item);
    });

    const total = items.length;
    const totalPages = Math.ceil(total / perPage);

    function showPage(page) {
      const start = (page - 1) * perPage;
      const end = start + perPage;
      items.forEach(function (item, i) {
        item.style.display = i >= start && i < end ? "" : "none";
      });
      return { start, end, page, totalPages };
    }

    const nav = document.createElement("nav");
    nav.className = "blogs-list__nav section__container page-width";
    nav.setAttribute("aria-label", "Blog posts pagination");

    if (isLoadMore) {
      let currentShown = perPage;
      showPage(1);
      items.forEach(function (item, i) {
        item.style.display = i < perPage ? "" : "none";
      });

      const loadMoreWrap = document.createElement("div");
      loadMoreWrap.className = "blogs-list__load-more text-center mt-6";
      const loadMoreBtn = document.createElement("button");
      loadMoreBtn.type = "button";
      loadMoreBtn.className = "btn btn--primary blogs-list__load-more-btn";
      const loadMoreText = document.createElement("span");
      loadMoreText.className = "btn__text";
      loadMoreText.textContent = "Load more";
      loadMoreBtn.appendChild(loadMoreText);

      function updateLoadMore() {
        if (currentShown >= total) {
          loadMoreWrap.style.display = "none";
          return;
        }
        loadMoreWrap.style.display = "";
        loadMoreText.textContent = "Load more";
      }

      loadMoreBtn.addEventListener("click", function () {
        currentShown = Math.min(currentShown + perPage, total);
        items.forEach(function (item, i) {
          item.style.display = i < currentShown ? "" : "none";
        });
        updateLoadMore();
      });

      loadMoreWrap.appendChild(loadMoreBtn);
      nav.appendChild(loadMoreWrap);
      updateLoadMore();
    } else {
      const paginationNav = document.createElement("nav");
      paginationNav.className = "pagination text-center";
      paginationNav.setAttribute("role", "navigation");
      paginationNav.setAttribute("aria-label", "Blog posts pagination");

      const iconCaretLeft =
        '<svg class="icon icon-caret-left rtl-flip-x icon--extra-small icon--thick" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M12.5 16.25L6.25 10L12.5 3.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      const iconCaretRight =
        '<svg class="icon icon-caret-right rtl-flip-x icon--extra-small icon--thick" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M7.5 3.75L13.75 10L7.5 16.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      let currentPage = 1;
      showPage(1);

      function getPageWindow() {
        const windowSize = 5;
        if (totalPages <= windowSize) {
          return { start: 1, end: totalPages };
        }
        let start = Math.max(1, currentPage - 2);
        let end = Math.min(totalPages, start + windowSize - 1);
        if (end - start + 1 < windowSize) {
          start = Math.max(1, end - windowSize + 1);
        }
        return { start, end };
      }

      function renderPagination() {
        paginationNav.innerHTML = "";
        if (totalPages <= 1) return;

        const ul = document.createElement("ul");
        ul.className =
          "pagination__list list-unstyled flex items-center flex-wrap justify-center";
        ul.setAttribute("role", "list");

        const prevLi = document.createElement("li");
        const prevBtn = document.createElement("button");
        prevBtn.type = "button";
        prevBtn.className =
          "pagination__item pagination__item--previous pagination__item-arrow motion-reduce";
        prevBtn.setAttribute("aria-label", "Previous page");
        prevBtn.innerHTML = iconCaretLeft + "<span>Previous</span>";
        prevBtn.disabled = currentPage === 1;
        prevBtn.addEventListener("click", function () {
          if (currentPage > 1) {
            currentPage--;
            showPage(currentPage);
            renderPagination();
            scrollBlogsListToTop();
          }
        });
        prevLi.appendChild(prevBtn);
        ul.appendChild(prevLi);

        const win = getPageWindow();
        if (win.start > 1) {
          const ellipsisLi = document.createElement("li");
          const ellipsis = document.createElement("span");
          ellipsis.className = "pagination__item";
          ellipsis.textContent = "…";
          ellipsisLi.appendChild(ellipsis);
          ul.appendChild(ellipsisLi);
        }
        for (let p = win.start; p <= win.end; p++) {
          const li = document.createElement("li");
          const pageBtn = document.createElement("button");
          pageBtn.type = "button";
          pageBtn.className =
            "pagination__item" +
            (p === currentPage
              ? " pagination__item--current background-2"
              : "");
          pageBtn.setAttribute("aria-label", "Page " + p);
          if (p === currentPage) pageBtn.setAttribute("aria-current", "page");
          pageBtn.textContent = p;
          pageBtn.addEventListener("click", function () {
            currentPage = p;
            showPage(currentPage);
            renderPagination();
            scrollBlogsListToTop();
          });
          li.appendChild(pageBtn);
          ul.appendChild(li);
        }
        if (win.end < totalPages) {
          const ellipsisLi = document.createElement("li");
          const ellipsis = document.createElement("span");
          ellipsis.className = "pagination__item";
          ellipsis.textContent = "…";
          ellipsisLi.appendChild(ellipsis);
          ul.appendChild(ellipsisLi);
        }

        const nextLi = document.createElement("li");
        const nextBtn = document.createElement("button");
        nextBtn.type = "button";
        nextBtn.className =
          "pagination__item pagination__item--next pagination__item-arrow motion-reduce";
        nextBtn.setAttribute("aria-label", "Next page");
        nextBtn.innerHTML = "<span>Next</span>" + iconCaretRight;
        nextBtn.disabled = currentPage === totalPages;
        nextBtn.addEventListener("click", function () {
          if (currentPage < totalPages) {
            currentPage++;
            showPage(currentPage);
            renderPagination();
            scrollBlogsListToTop();
          }
        });
        nextLi.appendChild(nextBtn);
        ul.appendChild(nextLi);

        paginationNav.appendChild(ul);
      }

      renderPagination();
      nav.appendChild(paginationNav);
    }

    list.parentNode.insertBefore(nav, list.nextSibling);
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function toUnixSeconds(dateTimeStr) {
    if (!dateTimeStr) return 0;
    const ms = Date.parse(dateTimeStr);
    if (!Number.isFinite(ms)) return 0;
    return Math.floor(ms / 1000);
  }

  function formatDate(dateTimeStr) {
    const ms = Date.parse(dateTimeStr);
    if (!Number.isFinite(ms)) return "";
    const d = new Date(ms);
    try {
      return d.toLocaleDateString(undefined, {
        year: "numeric",
        month: "short",
        day: "2-digit",
      });
    } catch (e) {
      return d.toDateString();
    }
  }

  function toHandle(value) {
    return String(value || "")
      .trim()
      .toLowerCase()
      .replace(/&/g, " and ")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  function getBlogHandleFromUrl(url) {
    if (!url) return "";
    const match = String(url).match(/\/blogs\/([^/]+)/i);
    return match && match[1] ? toHandle(match[1]) : "";
  }

  function getSelectedBlogHandle(container) {
    const q = new URLSearchParams(window.location.search);
    const queryHandle = toHandle(
      q.get("blog") ||
        q.get("type") ||
        (container && container.dataset.selectedBlog) ||
        "",
    );
    if (queryHandle) return queryHandle;
    return getBlogHandleFromUrl(window.location.pathname || "");
  }

  function updateActiveFilterLinks(selectedBlogHandle) {
    const sel = toHandle(selectedBlogHandle || "");
    document.querySelectorAll(".blogs-list-template__category-link").forEach(
      (linkEl) => {
        const linkBlog = toHandle(
          linkEl.getAttribute("data-blog-handle") != null
            ? linkEl.dataset.blogHandle || ""
            : linkEl.dataset.filterValue || "",
        );
        const isActive = sel === linkBlog;
        linkEl.classList.toggle(
          "blogs-list-template__category-link--active",
          isActive,
        );
      },
    );
  }

  function resetPagination(container) {
    container.querySelectorAll(".blogs-list__nav").forEach((el) => el.remove());
    delete container.dataset.blogsPaginationInitialized;
  }

  function decodeHtmlEntities(value) {
    return String(value || "")
      .replace(/&amp;lt;/gi, "&lt;")
      .replace(/&amp;gt;/gi, "&gt;")
      .replace(/&amp;quot;/gi, "&quot;")
      .replace(/&amp;#0?39;/gi, "&#39;")
      .replace(/&amp;amp;/gi, "&amp;")
      .replace(/&lt;/gi, "<")
      .replace(/&gt;/gi, ">")
      .replace(/&quot;/gi, '"')
      .replace(/&#0?39;/g, "'")
      .replace(/&nbsp;/gi, " ");
  }

  function stripStyleAndScriptBlocks(html) {
    let s = String(html || "");
    s = s.replace(/<script\b[^>]*>[\s\S]*?<\/script>/gi, " ");
    s = s.replace(/<style\b[^>]*>[\s\S]*?<\/style>/gi, " ");
    s = s.replace(/<style\b[^>]*>/gi, " ");
    s = s.replace(/<\/style\s*>/gi, " ");
    s = s.replace(/<noscript\b[^>]*>[\s\S]*?<\/noscript>/gi, " ");
    return s;
  }

  function stripCssLikeSegments(text) {
    let s = String(text || "");
    let prev;
    let guard = 0;
    do {
      prev = s;
      s = s.replace(/(?:^|[\s}])[.#@][a-zA-Z0-9_.,#:>\s()*+~"'=\[\]-]*\{[^{}]*\}/g, " ");
      guard++;
    } while (s !== prev && guard < 40);
    return s;
  }

  function looksLikeCssLeading(text) {
    const head = String(text || "").trimStart().slice(0, 160).toLowerCase();
    if (!head) return false;
    if (/^[.#@][a-z0-9_.,#:>\s-]{0,80}\{/.test(head)) return true;
    if (
      /^(?:position|padding|margin|display|width|height|overflow|font|color|background|border|line-height)\s*:/.test(
        head,
      )
    ) {
      return true;
    }
    return false;
  }

  function findProseCutover(text) {
    const len = text.length;
    let i = 0;
    let guard = 0;
    while (i < len && guard < 400) {
      guard++;
      while (i < len && /\s/.test(text[i])) i++;
      if (i >= len) break;
      const ahead = text.slice(i, Math.min(i + 256, len));
      const selMatch = ahead.match(/^[.#@][a-zA-Z0-9_.,#:>\s()*+~"'=\[\]-]*\{/);
      if (selMatch) {
        const openIdx = i + selMatch[0].length - 1;
        let depth = 1;
        let j = openIdx + 1;
        while (j < len && depth > 0) {
          if (text[j] === "{") depth++;
          else if (text[j] === "}") depth--;
          j++;
        }
        if (depth === 0) {
          i = j;
          continue;
        }
        return -1;
      }
      return i;
    }
    return -1;
  }

  function dropLeadingCss(text) {
    const s = String(text || "").trimStart();
    if (!s) return "";
    if (!looksLikeCssLeading(s)) return s;
    const cleaned = stripCssLikeSegments(s).replace(/\s+/g, " ").trim();
    if (cleaned && !looksLikeCssLeading(cleaned)) return cleaned;
    const cut = findProseCutover(s);
    if (cut > 0 && cut < s.length) {
      const tail = s.slice(cut).trim();
      if (tail && !looksLikeCssLeading(tail)) return tail;
    }
    return "";
  }

  function normalizeExcerpt(value) {
    if (!value) return "";
    let html = decodeHtmlEntities(value);
    html = stripStyleAndScriptBlocks(html);

    let text = "";
    try {
      const el = document.createElement("div");
      el.innerHTML = html;
      text = (el.textContent || el.innerText || "")
        .replace(/\s+/g, " ")
        .trim();
    } catch (_) {
      text = html.replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();
    }

    text = stripStyleAndScriptBlocks(text);
    text = stripCssLikeSegments(text).replace(/\s+/g, " ").trim();

    text = dropLeadingCss(text);

    return text.replace(/\s+/g, " ").trim();
  }

  function renderArticleCard(article, config) {
    const image = article.image || null;
    const title = article.title || "";
    const url = article.url || "#";
    const excerptCandidates = [
      article.content,
      article.contentHtml,
      article.excerpt,
      article.summary,
    ];
    let excerpt = "";
    for (const candidate of excerptCandidates) {
      if (!candidate) continue;
      const normalized = normalizeExcerpt(candidate);
      if (normalized) {
        excerpt = normalized;
        break;
      }
    }
    const authorName =
      (article.authorV2 && article.authorV2.name) || article.author || "";
    const publishedAt = article.publishedAt || "";

    const ratioSetting = config.imageRatio || "1/1";
    let aspectRatio = ratioSetting;
    if (ratioSetting === "adapt" && image && image.width && image.height) {
      aspectRatio = String(image.width / image.height);
    }

    const showDate = Boolean(config.showDate);
    const showAuthor = Boolean(config.showAuthor);
    const showExcerpt = Boolean(config.showExcerpt);
    const titleSize = config.titleSize ? String(config.titleSize) : "";
    const buttonLabel = config.buttonLabel || "Read more";
    const buttonStyle = config.buttonStyle || "btn--secondary";

    const dateHtml =
      showDate || showAuthor
        ? [
            showDate
              ? `<span class="article-card__meta article-card__date">${escapeHtml(
                  formatDate(publishedAt),
                )}</span>`
              : "",
            showDate && showAuthor
              ? `<span class="article-card__separator no-empty rounded self-center"></span>`
              : "",
            showAuthor
              ? `<span class="article-card__meta article-card__author">${escapeHtml(
                  authorName,
                )}</span>`
              : "",
          ].join("")
        : "";

    const excerptHtml =
      showExcerpt && excerpt
        ? `<p class="article-card__excerpt text-limit-2-lines text-subtext">${escapeHtml(
            excerpt,
          )}</p>`
        : "";

    const buttonHtml = `<a href="${escapeHtml(url)}" class="btn ${escapeHtml(
      buttonStyle,
    )} article-card__button"><span class="btn__text">${escapeHtml(
      buttonLabel,
    )}</span></a>`;

    const hasButton = true;

    const imgHtml =
      image && image.url
        ? `<img
            src="${escapeHtml(image.url)}"
            alt="${escapeHtml(image.altText || title)}"
            loading="lazy"
            class="motion-reduce hover-scale-up"
            is="image-lazy"
          />`
        : `<div class="placeholder-svg" aria-hidden="true"></div>`;

    return `
      <div class="article-card article-card--standard">
        <div class="article-card__media blocks-radius">
          <a href="${escapeHtml(
            url,
          )}" class="block media-wrapper hover-wrapper" aria-label="${escapeHtml(
            title,
          )}">
            <motion-element class="block" data-motion="zoom-out-sm" style="--aspect-ratio: ${escapeHtml(
              aspectRatio,
            )};">
              ${imgHtml}
            </motion-element>
          </a>
        </div>
        <div class="article-card__content">
          <div class="article-card__content-inner">
            <h3 class="article-card__title${titleSize ? " " + escapeHtml(titleSize) : ""}">
              <a class="reversed-link" href="${escapeHtml(url)}">${escapeHtml(
                title,
              )}</a>
            </h3>

            ${
              dateHtml
                ? `<div class="article-card__metas text-sm flex gap-2 text-subtext">${dateHtml}</div>`
                : ""
            }

            ${excerptHtml}

            ${hasButton ? buttonHtml : ""}
          </div>
        </div>
      </div>
    `.trim();
  }

  function mapArticleNodesToItems(articleNodes) {
    return articleNodes
      .filter(Boolean)
      .map((article) => {
        const articleTags = Array.isArray(article.tags)
          ? article.tags
          : typeof article.tags === "string" && article.tags.length > 0
            ? article.tags.split(",")
            : [];
        const articleTagHandles = articleTags.map((tag) => toHandle(tag));
        const articleUrl = article.url || "#";
        const blogHandleFromUrl = getBlogHandleFromUrl(articleUrl);
        const explicitBlogHandle = toHandle(
          article.blog_handle ||
            article.blogHandle ||
            (article.blog && article.blog.handle) ||
            "",
        );
        const publishedAt = article.publishedAt || article.published_at || "";
        const updatedAt =
          article.updatedAt ||
          article.updated_at ||
          article.editedAt ||
          article.edited_at ||
          article.modifiedAt ||
          article.modified_at ||
          publishedAt;
        return {
          title: article.title || "",
          publishedAt,
          publishedUnix: toUnixSeconds(publishedAt),
          updatedUnix:
            toUnixSeconds(updatedAt) || toUnixSeconds(publishedAt) || 0,
          tagHandles: articleTagHandles,
          blogHandle: explicitBlogHandle || blogHandleFromUrl,
          raw: {
            title: article.title || "",
            publishedAt,
            updatedAt,
            excerpt:
              article.content ||
              article.contentHtml ||
              article.excerpt ||
              article.summary ||
              "",
            url: articleUrl,
            image: article.image || null,
            tags: articleTags,
            authorV2:
              article.authorV2 ||
              (article.author ? { name: article.author } : null),
          },
        };
      });
  }

  async function ensureAllArticlesCached(container) {
    if (Array.isArray(container._mmBlogsNormalizedCache)) {
      return container._mmBlogsNormalizedCache;
    }
    if (container._mmBlogsFetchPromise) {
      return container._mmBlogsFetchPromise;
    }

    const proxyEndpoint = container.dataset.blogsProxyEndpoint || "";
    const articlesPerBlog = parseInt(
      container.dataset.articlesPerBlog || "50",
      10,
    );
    const emptyEl = container.querySelector(".blogs-list__empty");

    if (!proxyEndpoint) {
      if (emptyEl) emptyEl.style.display = "";
      container._mmBlogsNormalizedCache = [];
      return [];
    }

    container._mmBlogsFetchPromise = (async () => {
      container.dataset.blogsStorefrontLoading = "1";
      try {
        const url = new URL(proxyEndpoint, window.location.origin);
        url.searchParams.set("articles_per_blog", String(articlesPerBlog));

        const res = await fetch(url.toString(), {
          method: "GET",
          headers: {
            Accept: "application/json",
            "ngrok-skip-browser-warning": "true",
          },
        });

        if (!res.ok) {
          throw new Error(`Proxy request failed (${res.status})`);
        }

        const json = await res.json();
        const articleNodes = Array.isArray(json)
          ? json
          : Array.isArray(json.items)
            ? json.items
            : Array.isArray(json.articles)
              ? json.articles
              : [];

        const items = mapArticleNodesToItems(articleNodes);
        container._mmBlogsNormalizedCache = items;
        return items;
      } catch (e) {
        container._mmBlogsNormalizedCache = null;
        throw e;
      } finally {
        container.dataset.blogsStorefrontLoading = "0";
        container._mmBlogsFetchPromise = null;
      }
    })();

    return container._mmBlogsFetchPromise;
  }

  async function applyBlogFilterToDom(container, blogHandleRaw) {
    const list = container.querySelector(".blogs-list__articles");
    const emptyEl = container.querySelector(".blogs-list__empty");
    if (!list) return;

    const buttonLabel = container.dataset.articleButtonLabel || "Read more";
    const config = {
      showDate: container.dataset.showDate === "true",
      showAuthor: container.dataset.showAuthor === "true",
      showExcerpt: container.dataset.showExcerpt === "true",
      titleSize: container.dataset.titleSize || "",
      imageRatio: container.dataset.imageRatio || "1/1",
      buttonLabel,
      buttonStyle: "btn--secondary",
    };

    const blogHandle = toHandle(blogHandleRaw || "");

    try {
      const allItems = await ensureAllArticlesCached(container);
      const filtered = !blogHandle
        ? allItems
        : allItems.filter((item) => item.blogHandle === blogHandle);

      const frag = document.createDocumentFragment();
      list.innerHTML = "";
      container.dataset.blogsItemsReady = "1";

      for (const item of filtered) {
        const wrapper = document.createElement("div");
        wrapper.className = "blogs-list__article-item f-column";
        wrapper.dataset.title = item.title || "";
        wrapper.dataset.published = String(item.publishedUnix || 0);
        wrapper.dataset.updated = String(item.updatedUnix || 0);
        wrapper.innerHTML = renderArticleCard(item.raw, config);
        frag.appendChild(wrapper);
      }

      list.appendChild(frag);
      if (emptyEl) emptyEl.style.display = filtered.length ? "none" : "";
      container.dataset.blogsItemsReady = "1";
      resetPagination(container);
      if (filtered.length > 0) {
        init(container);
      }
      container.dataset.blogsStorefrontLoaded = "1";
    } catch (e) {
      console.warn("Blogs proxy endpoint unavailable", e);
      if (emptyEl) emptyEl.style.display = "";
      list.innerHTML = "";
      resetPagination(container);
      delete container.dataset.blogsStorefrontLoaded;
    }
  }

  function setupSectionBlogFilters(container) {
    if (container.dataset.blogsFilterNavBound === "1") return;
    const sectionEl = container.closest(".blogs-list-template");
    if (!sectionEl) return;
    container.dataset.blogsFilterNavBound = "1";

    sectionEl.addEventListener("click", function (e) {
      const link = e.target.closest("a.blogs-list-template__category-link");
      if (!link || !sectionEl.contains(link)) return;
      if (e.defaultPrevented) return;
      if (e.button !== 0) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;
      let navUrl;
      try {
        navUrl = new URL(link.href, window.location.origin);
      } catch (_) {
        return;
      }
      if (navUrl.origin !== window.location.origin) return;
      if (navUrl.pathname !== window.location.pathname) return;
      e.preventDefault();
      const blog = toHandle(
        link.dataset.blogHandle || link.dataset.filterValue || "",
      );

      const u = new URL(window.location.href);
      u.searchParams.delete("type");
      if (blog) {
        u.searchParams.set("blog", blog);
      } else {
        u.searchParams.delete("blog");
      }
      history.pushState({ mmBlogFilter: blog }, "", u.toString());

      void applyBlogFilterToDom(container, blog);
      updateActiveFilterLinks(blog);
    });
  }

  if (!window.__mmBlogsListPopstateBound) {
    window.__mmBlogsListPopstateBound = true;
    window.addEventListener("popstate", function () {
      document.querySelectorAll(".blogs-list-js").forEach((c) => {
        if (c.dataset.blogsStorefrontLoaded !== "1") return;
        const blog = getSelectedBlogHandle(c);
        void applyBlogFilterToDom(c, blog);
        updateActiveFilterLinks(blog);
      });
    });
  }

  async function initStorefront(container) {
    if (!container) return;
    const blog = getSelectedBlogHandle(container);
    updateActiveFilterLinks(blog);
    await applyBlogFilterToDom(container, blog);
    setupSectionBlogFilters(container);
  }

  document.querySelectorAll(".blogs-list-js").forEach((container) => {
    void initStorefront(container);
  });

  document.addEventListener("shopify:section:load", function (e) {
    const root = e && e.target;
    if (!root || !root.querySelector) return;
    const c = root.querySelector(".blogs-list-js");
    if (c) void initStorefront(c);
  });
})();
